import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import paymentMethodService from "services/paymentMethodService";

export const usePaymentMethodList = (payload, onSuccess, onError) => {
  const { enabled, params } = payload;
  return useQuery(
    ["payment-method-list", params],
    () => paymentMethodService.getPaymentMethodList(params),
    {
      enabled: enabled || false,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError,
      initialData: Object({ data: {} }),
      select: response => {
        const { data } = response;
        return {
          items: data.items || [],
          params: params,
          meta: data._meta,
        };
      },
    }
  );
};

export const useCreatePaymentMethod = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["paymentMethod"]);
  const { addToast } = useToasts();

  return useMutation(paymentMethodService.createPaymentMethod, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.create", {
          target: t("paymentMethod"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.create", {
              target: t("paymentMethod"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useUpdatePaymentMethod = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["paymentMethod"]);
  const { addToast } = useToasts();

  return useMutation(paymentMethodService.updatePaymentMethod, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("paymentMethod"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("paymentMethod"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useUpdateStatusPaymentMethod = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["paymentMethod"]);
  const { addToast } = useToasts();

  return useMutation(paymentMethodService.updateStatusPaymentMethod, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("paymentMethod"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("paymentMethod"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
